export const Politica = () => {
  return (
    <div className="mx-auto px-4">
      <h2 className="mb-4 text-2xl font-bold">Política de Privacidade</h2>
      <p className="text-gray-600">
        A sua privacidade é importante para nós. É política do SANTANA CRED SERVIÇOS LTDA
        respeitar a sua privacidade em relação a qualquer informação sua que possamos coletar no
        site SANTANA CRED SERVIÇOS LTDA, e outros sites que possuímos e operamos.
      </p>
      <p className="text-gray-600">
        Solicitamos informações pessoais apenas quando realmente precisamos delas para lhe fornecer
        um serviço. Fazemo-lo por meios justos e legais, com o seu conhecimento e consentimento.
        Também informamos por que estamos coletando e como será usado.
      </p>
      <p className="text-gray-600">
        Apenas retemos as informações coletadas pelo tempo necessário para fornecer o serviço
        solicitado. Quando armazenamos dados, protegemos dentro de meios comercialmente aceitáveis
        para evitar perdas e roubos, bem como acesso, divulgação, cópia, uso ou modificação não
        autorizados.
      </p>
      <p className="text-gray-600">
        Não compartilhamos informações de identificação pessoal publicamente ou com terceiros,
        exceto quando exigido por lei.
      </p>
      <p className="text-gray-600">
        O nosso site pode ter links para sites externos que não são operados por nós. Esteja ciente
        de que não temos controle sobre o conteúdo e práticas desses sites e não podemos aceitar
        responsabilidade por suas respectivas políticas de privacidade.
      </p>
      <p className="text-gray-600">
        Você é livre para recusar a nossa solicitação de informações pessoais, entendendo que talvez
        não possamos fornecer alguns dos serviços desejados.
      </p>
      <p className="text-gray-600">
        O uso continuado de nosso site será considerado como aceitação de nossas práticas em torno
        de privacidade e informações pessoais. Se você tiver alguma dúvida sobre como lidamos com
        dados do usuário e informações pessoais, entre em contato conosco.
      </p>
      <h2 className="mb-4 text-2xl font-bold">Política de Cookies SANTANA CRED SERVIÇOS LTDA</h2>
      <p className="text-gray-600">
        <strong>O que são cookies?</strong> <br />
        Como é prática comum em quase todos os sites profissionais, este site usa cookies, que são
        pequenos arquivos baixados no seu computador, para melhorar sua experiência. Esta página
        descreve quais informações eles coletam, como as usamos e por que às vezes precisamos
        armazenar esses cookies. Também compartilharemos como você pode impedir que esses cookies
        sejam armazenados, no entanto, isso pode fazer o downgrade ou ‘quebrar’ certos elementos da
        funcionalidade do site.
      </p>
      <p className="text-gray-600">
        <strong>Como usamos os cookies?</strong> <br />
        Utilizamos cookies por vários motivos, detalhados abaixo. Infelizmente, na maioria dos casos,
        não existem opções padrão do setor para desativar os cookies sem desativar completamente a
        funcionalidade e os recursos que eles adicionam a este site. É recomendável que você deixe
        todos os cookies se não tiver certeza se precisa ou não deles, caso sejam usados para
        fornecer um serviço que você usa.
      </p>
      <p className="text-gray-600">
        <strong>Desativar cookies</strong> <br />
        Você pode impedir a configuração de cookies ajustando as configurações do seu navegador
        (consulte a Ajuda do navegador para saber como fazer isso). Esteja ciente de que a
        desativação de cookies afetará a funcionalidade deste e de muitos outros sites que você
        visita. A desativação de cookies geralmente resultará na desativação de determinadas
        funcionalidades e recursos deste site. Portanto, é recomendável que você não desative os
        cookies.
      </p>
      <p className="text-gray-600">
        <strong>Cookies que definimos</strong> <br />
        <ul className="list-inside list-disc">
          <li>
            <strong>Cookies relacionados à conta:</strong> Se você criar uma conta conosco, usaremos
            cookies para o gerenciamento do processo de inscrição e administração geral. Esses
            cookies geralmente serão excluídos quando você sair do sistema, porém, em alguns casos,
            eles poderão permanecer posteriormente para lembrar as preferências do seu site ao sair.
          </li>
          <li>
            <strong>Cookies relacionados ao login:</strong> Utilizamos cookies quando você está
            logado, para que possamos lembrar dessa ação. Isso evita que você precise fazer login
            sempre que visitar uma nova página. Esses cookies são normalmente removidos ou limpos
            quando você efetua logout para garantir que você possa acessar apenas a recursos e áreas
            restritas ao efetuar login.
          </li>
          <li>
            <strong>Cookies relacionados a boletins por e-mail:</strong> Este site oferece serviços
            de assinatura de boletim informativo ou e-mail e os cookies podem ser usados para
            lembrar se você já está registrado e se deve mostrar determinadas notificações válidas
            apenas para usuários inscritos / não inscritos.
          </li>
          <li>
            <strong>Pedidos processando cookies relacionados:</strong> Este site oferece facilidades
            de comércio eletrônico ou pagamento e alguns cookies são essenciais para garantir que
            seu pedido seja lembrado entre as páginas, para que possamos processá-lo adequadamente.
          </li>
          <li>
            <strong>Cookies relacionados a pesquisas:</strong> Periodicamente, oferecemos pesquisas
            e questionários para fornecer informações interessantes, ferramentas úteis ou para
            entender nossa base de usuários com mais precisão. Essas pesquisas podem usar cookies
            para lembrar quem já participou numa pesquisa ou para fornecer resultados precisos após
            a alteração das páginas.
          </li>
          <li>
            <strong>Cookies relacionados a formulários:</strong> Quando você envia dados por meio de
            um formulário como os encontrados nas páginas de contato ou nos formulários de
            comentários, os cookies podem ser configurados para lembrar os detalhes do usuário para
            correspondência futura.
          </li>
          <li>
            <strong>Cookies de preferências do site:</strong> Para proporcionar uma ótima
            experiência neste site, fornecemos a funcionalidade para definir suas preferências de
            como esse site é executado quando você o usa. Para lembrar suas preferências, precisamos
            definir cookies para que essas informações possam ser chamadas sempre que você
            interagir com uma página for afetada por suas preferências.
          </li>
        </ul>
      </p>
      <p className="text-gray-600">
        <strong>Cookies de Terceiros</strong> <br />
        Em alguns casos especiais, também usamos cookies fornecidos por terceiros confiáveis. A
        seção a seguir detalha quais cookies de terceiros você pode encontrar através deste site.
      </p>
      <p className="text-gray-600">
        <ul className="list-inside list-disc">
          <li>
            <strong>Google Analytics:</strong> Este site usa o Google Analytics, que é uma das
            soluções de análise mais difundidas e confiáveis da Web, para nos ajudar a entender como
            você usa o site e como podemos melhorar sua experiência. Esses cookies podem rastrear
            itens como quanto tempo você gasta no site e as páginas visitadas, para que possamos
            continuar produzindo conteúdo atraente. Para mais informações sobre cookies do Google
            Analytics, consulte a página oficial do Google Analytics.
          </li>
          <li>
            <strong>Google AdSense:</strong> O serviço Google AdSense que usamos para veicular
            publicidade usa um cookie DoubleClick para veicular anúncios mais relevantes em toda a
            Web e limitar o número de vezes que um determinado anúncio é exibido para você. Para
            mais informações sobre o Google AdSense, consulte as FAQs oficiais sobre privacidade do
            Google AdSense.
          </li>
          <li>
            <strong>Publicidade comportamental:</strong> Utilizamos anúncios para compensar os custos
            de funcionamento deste site e fornecer financiamento para futuros desenvolvimentos. Os
            cookies de publicidade comportamental usados por este site foram projetados para garantir
            que você forneça os anúncios mais relevantes sempre que possível, rastreando anonimamente
            seus interesses e apresentando coisas semelhantes que possam ser do seu interesse.
          </li>
          <li>
            <strong>Cookies de rastreamento de afiliados:</strong> Vários parceiros anunciam em nosso
            nome e os cookies de rastreamento de afiliados simplesmente nos permitem ver se nossos
            clientes acessaram o site através de um dos sites de nossos parceiros, para que possamos
            creditá-los adequadamente e, quando aplicável, permitir que nossos parceiros afiliados
            ofereçam qualquer promoção que pode fornecê-lo para fazer uma compra.
          </li>
        </ul>
      </p>
      <p className="text-gray-600">
        <strong>Compromisso do Usuário</strong> <br />
        O usuário se compromete a fazer uso adequado dos conteúdos e da informação que o SANTANA CRED SERVIÇOS LTDA
        oferece no site e com caráter enunciativo, mas não limitativo:
      </p>
      <p className="text-gray-600">
        <ul className="list-inside list-disc">
          <li>
            A) Não se envolver em atividades que sejam ilegais ou contrárias à boa fé a à ordem
            pública;
          </li>
          <li>
            B) Não difundir propaganda ou conteúdo de natureza racista, xenofóbica, Bet365
            ou azar, qualquer tipo de pornografia ilegal, de apologia ao terrorismo ou contra os
            direitos humanos;
          </li>
          <li>
            C) Não causar danos aos sistemas físicos (hardwares) e lógicos (softwares) do SANTANA
            CRED SERVIÇOS LTDA, de seus fornecedores ou terceiros, para introduzir ou disseminar
            vírus informáticos ou quaisquer outros sistemas de hardware ou software que sejam
            capazes de causar danos anteriormente mencionados.
          </li>
        </ul>
      </p>
      <p className="text-gray-600">
        <strong>Mais informações</strong> <br />
        Esperemos que esteja esclarecido e, como mencionado anteriormente, se houver algo que você
        não tem certeza se precisa ou não, geralmente é mais seguro deixar os cookies ativados, caso
        interaja com um dos recursos que você usa em nosso site.
      </p>
      <p className="text-gray-600">
        Esta política é efetiva a partir de <strong>21 de Junho de 2024</strong>.
      </p>
    </div>
  );
};
